import z from 'zod';
import { ComponentType } from '$lib/sanity/types';
import { SanityDocumentSchema } from '../sanity';
import { PageCollectionThemeSchema } from '../shared';
import { MediaSchema } from './Media';

const GalleryPlacement = z.object({
  x: z
    .string()
    .nullish()
    .transform((x) => x ?? '0%'),
  y: z
    .string()
    .nullish()
    .transform((x) => x ?? '0%'),
  w: z
    .string()
    .nullish()
    .transform((x) => x ?? '50%'),
  h: z
    .string()
    .nullish()
    .transform((x) => x ?? 'auto')
});

export const PageGallerySchema = SanityDocumentSchema.extend({
  _type: z.literal(ComponentType.PageGallery),
  theme: PageCollectionThemeSchema.nullish(),
  sectionHeight: z.object({
    desktop: z
      .string()
      .nullish()
      .transform((x) => x ?? '600px'),
    mobile: z
      .string()
      .nullish()
      .transform((x) => x ?? '300px')
  }),
  hideVerticalOverflow: z
    .boolean()
    .nullish()
    .transform((x) => x ?? true),
  galleryItems: z.array(
    z.object({
      media: MediaSchema.nullish(),
      placement: z.object({
        desktop: GalleryPlacement,
        mobile: GalleryPlacement
      })
    })
  )
});

export type PageGallery = z.infer<typeof PageGallerySchema>;
